import { cn } from "@/lib/cn";

/** Active / Void pill for a recorded payment or retainer transaction. */
export function PaymentStatusPill({ status, className }) {
  const isVoid = status === "Void";
  return (
    <span
      data-testid={`payment-status-${isVoid ? "void" : "active"}`}
      className={cn(
        "inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium",
        isVoid
          ? "text-status-void border-status-void/30 bg-status-void/10 line-through decoration-1"
          : "text-status-paid border-status-paid/30 bg-status-paid/10",
        className
      )}
    >
      {isVoid ? "Void" : "Active"}
    </span>
  );
}
